module.exports = __webpack_public_path__ + "static/img/ljsyy.c73ed6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/ljsyy.png
// module id = K/Bq
// module chunks = 0